import { Component, OnInit, HostListener } from '@angular/core';

import { ActivatedRoute } from '@angular/router';

import { WpService } from '../service/wp.service'

import {Observable} from 'rxjs';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {

  offset: number;
  posts = [];
  last = false;

  @HostListener('window:scroll', ['$event'])
  scrolling(event){
    //console.log(event)
  }


  constructor(private wp: WpService, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.offset = 0;
    this.loadBlog()
  }

  loadBlog(){
    this.route.params.subscribe(data => {
      this.wp.get('blog/' + this.offset).subscribe(
        data => {
          if (data.length === 0) {
            this.last = true;
          }
          for( let post of data){
            post.post_date = new Date(post.post_date)
          }
          this.posts = this.posts.concat(data)
          this.offset = this.offset + 1;
        },
        error => {
          console.error(error)
        }
      )
    })
  }

}



// WEBPACK FOOTER //
// /home/leonhard/Projekte/braungardt/angular/src/app/blog/blog.component.ts